/**
 * Floor Plan Detail Plugin for Native Interactive Site Map
 *
 * Owns [data-panel] content when activeView === VIEW_FLOOR_PLAN_DETAIL. Intentionally blank —
 * mounts/unmounts correctly with the view state machine, renders no content yet. See
 * STORE_DESIGN.md's View State Machine section for the intended eventual content (Lot &
 * Elevation / Floor Plan Configuration tabs) — a future implementation fills in mount() below.
 *
 * Leaving this view has no dedicated control here, same as lotMapSelection: tapping the map
 * outside any lot dispatches navigateBack() from lotInteraction.plugin.js, which is
 * view-agnostic and already handles this view correctly.
 *
 * @module nativeInteractiveSiteMap/plugins/floorPlanDetail.plugin
 */

import { distinctUntilChanged, map } from 'rxjs/operators';
import { selectActiveView } from '../redux/selectors';
import { VIEW_FLOOR_PLAN_DETAIL } from '../constants';

export default function createFloorPlanDetailPlugin() {
  const state = {
    panel: null,
    store$: null,
    subscriptions: [],
  };

  function mount() {
    // Intentionally blank — see module docstring.
  }

  function remove() {
    // Nothing mounted yet to remove.
  }

  function onActiveViewChanged(activeView) {
    if (activeView === VIEW_FLOOR_PLAN_DETAIL) {
      mount();
    } else {
      remove();
    }
  }

  return {
    name: 'floor-plan-detail',

    async start(context) {
      state.panel = context.root.querySelector('[data-panel]');
      if (!state.panel) {
        return;
      }
      state.store$ = context.services.store$;

      state.subscriptions.push(
        state.store$.pipe(
          map(selectActiveView),
          distinctUntilChanged(),
        ).subscribe(onActiveViewChanged),
      );
    },

    async stop() {
      state.subscriptions.forEach((subscription) => subscription?.unsubscribe?.());
      state.subscriptions = [];
      remove();
      state.panel = null;
      state.store$ = null;
    },
  };
}
